import { useEffect, useMemo, useState } from 'react';
import Layout from "../../components/layout/Layout";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { eventsColumns } from "./eventsTableData";
import { getEvents, deleteEvent } from "../../api/eventsService";

import {
  ActionContainer,
  AddEvent,
  DataGridContainer,
  DataGridWrapper,
} from "./style";
import { Link, useLocation } from "react-router-dom";
import { useData } from "../../hooks/useData";
import { useAuth } from "../../hooks/useAuth";

type ListType = "User" | "Product" | "Order" | "Events";

const Events = () => {
  const location = useLocation();
  const { isAdmin } = useAuth();
  // change content on different path
  const type: ListType = "Events";

  const [events, setEvents]: any = useState([]);

  // Custom Hook for fathing data
  const data = useData(type);

  useEffect(() => {
    getEvents().then((data) => {
      const map_data: any = [];
      data.map((item: any) => {
        map_data.push({
          ...item,
          areas: `${item.width | 0} * ${item.height | 0}`,
        })
        item.width = item.width
      })
      setEvents(map_data);
    });
    return () => {

    }
  }, []);

  const todayStart = useMemo(() => new Date().setHours(0, 0, 0, 0), []);
  const { upcomingEvents, pastEvents } = useMemo(() => {
    const upcoming: any[] = [];
    const past: any[] = [];
    events.forEach((item: any) => {
      const startDate = item.start_date ? new Date(item.start_date).getTime() : 0;
      if (startDate >= todayStart) {
        upcoming.push(item);
      } else {
        past.push(item);
      }
    });
    upcoming.sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime());
    past.sort((a, b) => new Date(b.start_date).getTime() - new Date(a.start_date).getTime());
    return { upcomingEvents: upcoming, pastEvents: past };
  }, [events, todayStart]);


  // Handle deleting user from db
  const handleDelete = async (id: string) => {
    try {
      await deleteEvent(id);
      const filtered_data: any = events.filter((item: any) => item.id !== id);
      setEvents(filtered_data);
    } catch (err) {
      console.log(err);
    }
  };
  // Generic table fields
  const actions: GridColDef[] = [
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => {
        return (
          <ActionContainer>
            <Link
              to={`${location.pathname}/${params.row.id}`}
              state={{ ...params.row }}
              style={{ textDecoration: "none" }}
            >
              <button className="btn viewBtn">Edit</button>
            </Link>
            {/* <Link
              to={`/exhibitors/${params.row.id}`}
              state={{ ...params.row }}
              style={{ textDecoration: "none" }}
            >
              <button className="btn viewBtn">View</button>
            </Link> */}
            <Link
              to={`${location.pathname}/${params.row.id}/products`}
              state={{ ...params.row }}
              style={{ textDecoration: "none" }}
            >
              <button className="btn viewBtn">Products</button>
            </Link>
            {isAdmin && (
            <button
              onClick={() => handleDelete(params.row.id)}
              className="btn deleteBtn"
            >
              Delete
            </button>
            )}
          </ActionContainer>
        );
      },
    },
  ];

  return (
    <Layout>
      {!(location.pathname === "/orders") && (
        <AddEvent>
          <h1 className="title">Events</h1>
          {isAdmin && (
          <Link
            to={`${location.pathname}/new`}
            state={{ type }}
            style={{ textDecoration: "none" }}
          >
            <button className="add">Add Event</button>
          </Link>
          )}
        </AddEvent>
      )}

      <DataGridWrapper>
        <h2 style={{ marginBottom: 8, marginTop: 8 }}>Upcoming events</h2>
        <DataGridContainer>
          <DataGrid
            style={{ backgroundColor: "#fff" }}
            rows={upcomingEvents}
            columns={eventsColumns.concat(actions)}
            pageSize={10}
            rowsPerPageOptions={[10]}
          />
        </DataGridContainer>
        <h2 style={{ marginBottom: 8, marginTop: 32 }}>Past events</h2>
        <DataGridContainer>
          <DataGrid
            style={{ backgroundColor: "#fff" }}
            rows={pastEvents}
            columns={eventsColumns.concat(actions)}
            pageSize={10}
            rowsPerPageOptions={[10]}
          />
        </DataGridContainer>
      </DataGridWrapper>
    </Layout>
  );
};

export default Events;
